import { createSelector } from 'reselect'
import getFastTrackExpireOnNextTierLoyaltySelect from 'modules/loyalty/redux/selectors/get-expire-on-fast-track-next-tier'
import getFastTrackExtensionExpirationDateLoyaltySelect from 'modules/loyalty/redux/selectors/get-fast-track-extension-expiration-date'
import isAfterDateUtil from 'utils/date/is-after'

const isFastTrackExpiredLoyaltySelect = createSelector(
  getFastTrackExpireOnNextTierLoyaltySelect,
  getFastTrackExtensionExpirationDateLoyaltySelect,
  /**
   * @param {Date|null} fastTrackExpirationDateStr
   * @param {Date|null} fastTrackExtensionExpirationDateStr
   */
  (fastTrackExpirationDateStr, fastTrackExtensionExpirationDateStr) => {
    if (!fastTrackExpirationDateStr || !fastTrackExtensionExpirationDateStr) {
      return false
    }
    const now = new Date()
    const fastTrackExpirationDate = new Date(fastTrackExpirationDateStr)
    const fastTrackExtensionExpirationDate = new Date(fastTrackExtensionExpirationDateStr)
    return (
      isAfterDateUtil(now, fastTrackExpirationDate) &&
      isAfterDateUtil(now, fastTrackExtensionExpirationDate)
    )
  }
)

export default isFastTrackExpiredLoyaltySelect
